<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="合同编号">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.contractNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.contractName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="对方公司名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.otherCompany"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="selectBox">
          <span class="selectText">签订日期</span>
          <el-date-picker
            size="mini"
            v-model="signDate"
            @change="signDateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
        <div class="selectBox">
          <span class="selectText">是否到期</span>
          <el-select
            v-model="queryParam.isEnd"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="请选择" value></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span class="selectText">是否有合同</span>
          <el-select
            v-model="queryParam.haveContract"
            size="mini"
            placeholder="请选择"
          >
            <el-option label="请选择" value></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </div>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button size="mini" type="primary" @click="handleAdd()"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #isEnd="slotData">
        <p v-if="slotData.data.row.isEnd == 1">是</p>
        <p v-if="slotData.data.row.isEnd == 0">否</p>
      </template>
      <template #signDate="slotData">
        {{slotData.data.row.signDate | sliceDate}}
      </template>
      <template #startDate="slotData">
        {{slotData.data.row.startDate | sliceDate}}
      </template>
      <template #endDate="slotData">
        {{slotData.data.row.endDate | sliceDate}}
      </template>
      
      <!-- <template #photo="slotData">
        <el-image
          v-if="slotData.data.row.productImage"
          style="width: 100px; height: 50px"
          :src="slotData.data.row.productImage"
          :preview-src-list="[slotData.data.row.productImage]"
          :key="slotData.data.row.id"
        >
          <div
            slot="error"
            class="image-slot"
            style="width: 100px; height: 50px"
          >
            <img
              src="@/assets/imgFail.png"
              alt
              style="width: 60px; height: 40px"
            />
          </div>
        </el-image>
        <span style="color: gray" v-else>暂无</span>
      </template> -->
      <template #haveContract="slotData">
        <p v-if="slotData.data.row.haveContract == 1">是</p>
        <p v-if="slotData.data.row.haveContract == 0">否</p>
      </template>
      <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleEdit(slotData.data.row)"
          >修改</el-button
        >
        <el-button
          size="mini"
          type="success"
          @click="handleDetail(slotData.data.row, true)"
          >详情</el-button
        >
        <el-popconfirm
          style="margin-left: 10px"
          title="确定删除吗？"
          @confirm="handleDelete(slotData.data.row.id)"
        >
          <template #reference>
            <el-button size="mini" type="danger">删除</el-button>
          </template>
        </el-popconfirm>
      </template>
    </e-table>
    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import modalForm from "./component/userModal";

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable, modalForm },
  mixins: [listMixin],
  props: {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  data() {
    return {
      signDate: "",
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() >= Date.now();
        },
      },
      deleteKey: "userId",
      url: {
        list: "/wlIncomeContract/queryPage",
        delete: "/wlIncomeContract/delContract",
      },
      //字段权限
      columns: [
        {
          field: "contractNo",
          label: "合同编号",
        },
        {
          field: "contractName",
          label: "合同名称",
          width: 100,
        },
        {
          field: "otherCompany",
          label: "对方公司名称",
          width: 100,
        },
        {
          field: "contractAmount",
          label: "合同金额",
          width: 100,
        },
        {
          field: "signDate",
          label: "签订日期",
          width: 100,
          slotName: "signDate",
          columnType: "slot",
        },
        {
          field: "startDate",
          label: "起始日期",
          width: 100,
          slotName: "startDate",
          columnType: "slot",
        },
        {
          field: "endDate",
          label: "截止日期",
          width: 100,
          slotName: "endDate",
          columnType: "slot",
        },
        {
          field: "receivableAmount",
          label: "应收账款余额",
          width: 100,
        },

        {
          field: "isEnd",
          label: "是否到期",
          width: 100,
          slotName: "isEnd",
          columnType: "slot",
        },
        {
          field: "haveContract",
          label: "是否有合同",
          width: 100,
          slotName: "haveContract",
          columnType: "slot",
        },
        { field: "remark", label: "备注" },

        {
          width: 260,
          label: "编辑",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    searchReset() {
      this.queryParam = {};
      this.signDate = "";
      this.loadData(1);
    },
    signDateChange(date) {
      if (date) {
        this.queryParam.signDateStrat = date[0] + " 00:00:00";
        this.queryParam.signDateEnd = date[1] + " 23:59:59";
      } else {
        this.queryParam.signDateStrat = "";
        this.queryParam.signDateEnd = "";
      }
    },
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
    handleDelete: function (id) {
        httpAction(this.url.delete + '?id=' + id, "get").then(
          (res) => {
            if (res.code == 200) {
              //重新计算分页问题
              this.reCalculatePage(1);
              this.$message.success("删除成功");
              this.onClearSelected();
              this.loadData();
            } else {
              this.$message.warning(res.msg);
            }
          }
        );
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  // width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
